import Axios from 'axios';
import store from './store';

const axios = Axios.create({
    baseURL: process.env.VUE_APP_API_BASE,
    headers: {
        'Content-Type': 'application/json',
    },
});

axios.interceptors.request.use(config => {
    const s = store.getToken();

    if (s && s.token) {
        config.headers['X-token'] = s.token;
    }
    config.headers['X-client-app-id'] = 'MBWEB';
    config.headers['X-org-id'] = process.env.VUE_APP_ORG_ID;
    return config;
}, error => {
    console.log(error);
});

axios.interceptors.response.use(resp => {
    // console.log(resp.headers);
    // if (resp.headers['Content-Type'].startsWith()('text/plain')) {
    //     return Promise.resolve(resp);
    // }

    if (resp.data.errorCode === 'err.login.required') {
        self.postMessage({
            type: 'JUMP_LOGIN',
            url : window.location.href,
        });
        return Promise.reject(resp.data);
    }

    if (('errorCode' in resp.data) && parseInt(resp.data.errorCode) !== 0 && !('x-bypass-error' in resp.headers)) {
        self.postMessage({
            type: 'TOAST',
            toastType: 'error',
            message: resp.data.errorMessage,
        });
        return Promise.reject(resp.data);
        // let errorData;
        // errorData = Object.assign({
        //         type: 'ERROR',
        //         requestId: null,
        //     }, resp.data);
        // window.postMessage(errorData, window.location.href);

        // return Promise.reject(errorData);
    }
    return Promise.resolve(resp);
}, err => {
    if (err.response && err.response.headers['x-bypass-error']) {
        return Promise.reject(err);
    }

    if (err.toJSON().status === 401 || err.response.data.errorCode === 'err.login.required') {
        window.postMessage({
            type: 'SHOW_LOGIN',
        }, window.location.origin);
    } else if (err.response && err.response.data) {
        console.log(JSON.stringify(err));
        window.postMessage(Object.assign({
            type: 'ERROR',
            requestId: err.response.headers['x-request-id'],
        }, err.response.data), window.location.href);
    } else {
        if (err.message === 'Network Error') {
            window.postMessage({
                type: 'INFO',
                shownColor: 'error',
                shownTitle: '网络异常',
            }, window.location.origin);

        } else {
            window.postMessage({
                type: 'ERROR',
                requestId: '-1',
                errorCode: err.name,
                errorMessage: err.message,
            }, window.location.origin);
        }
    }

    return Promise.reject(err);
});


export default axios;
